import { useMutation } from "react-query"
import api from "../client"

const deleteData = async (uuid: string | undefined) => {
    const { data } = await api.delete(
        `/address/${uuid}`,
    )
    return data
}

export const useDeleteAddress = (uuid: string | undefined) => {
    return useMutation(() => {
        return deleteData(uuid)
    })
}
